import { View } from "@/components/ui/view";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import React, { useState, useEffect } from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useDispatch, useSelector } from "react-redux";
import i18n from '@/assets/i18n';
import BasicElement from '@/components/basic/BasicElement';
import FloatingLabelInput from '@/components/basic/FloatingLabelInput';
import Footer from "@/components/basic/Footer";
import QRCodeView from '@/components/basic/QRCodeView';
import SwitchableElement from '@/components/basic/SwitchableElement';
import BackGesture from "@/containers/BackGesture";
import { switchScreen } from '@/hooks/navigate';
import { backendRequest } from "@/stores/thunks";
import PressableElement from '@/components/basic/PressableElement';
import ModalConfirm from '@/components/basic/ModalConfirm';
import avatar1 from "@/assets/images/avatar_mit_background.png"

export default function ShareQRCode({ navigation, route }) {
    const { task, isEdit } = route.params

    const dispatch = useDispatch()

    const server = useSelector((state) => state.server)
    const user = useSelector((state) => state.user)
    const share = useSelector((state) => state.published && state.published.find(share => share.workflow.id == task.workflowId))
    const insets = useSafeAreaInsets()
    const [info, setInfo] = useState(share?.info || '')
    const [anonymous, setAnonymous] = useState(share?.anonymous == undefined ? true : share.anonymous)
    const [active, setActive] = useState(share ? share?.active : true)
    const [showModal, setShowModal] = useState(false)

    const createShare = () => {
        console.log('SHARE_PUBLIC_INLINE', info)
        dispatch(backendRequest('SHARE_PUBLIC_INLINE', '/share/public/' + task.workflowId, {
            image: anonymous ? user.publicImage?.id : user.userImage?.id,
            name: anonymous ? user.publicName : (user.preferredName || user.mail),
            anonymous: anonymous,
            info: info,
            active: active
        }, share ? 'PUT' : 'POST', false)).then(data => console.log('PUBLIC', data.result))
    }

    useEffect(() => {
        navigation.setOptions({ title: task.title, info: i18n.t(share ? 'shareQRCode.info' : 'shareQRCode.infoNeu') })
    }, [share])

    const actions = [
        { icon: 'keyboard-arrow-left', text: 'footer.back', component: 'PublicWorkflows', params: { isEdit: false } },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        isEdit ? { icon: 'check', text: 'footer.finish', component: 'ShareQRCode', params: { task: task, isEdit: false }, exec: createShare } : (server.online ? { icon: 'edit', text: 'footer.edit', component: 'ShareQRCode', params: { task: task, isEdit: true } } : { icon: '' })
    ]

    const scanQRCode = () => {
        switchScreen(navigation, 'AuthenticateSession')
    }

    const inaUrl = 'https://ina.coach/starter/?qr=';
    const generatePDF = () => {
        switchScreen(navigation, 'PrintQRCode', { codes: [{ data: inaUrl + (share?.id || '00000000-0000-0000-0000-000000000001'), text: task.title }], single: true })
    }

    const closeModal = (confirmed) => {
        setShowModal(false)
        if (confirmed) {
            dispatch(backendRequest('DELETE_PUBLIC_INLINE', '/share/public/' + task.workflowId, '', 'DELETE', false))
            switchScreen(navigation, 'BACK')
        }
    }

    return (
        <BackGesture navigation={navigation}>
            <View className="flex-1 bg-secondary-50 pt-3">
                <ScrollView contentContainerStyle={{ paddingBottom: 140 + insets.bottom }}>
                    <VStack space='lg' className="w-[100%] items-center">
                        {share?.id && <QRCodeView data={inaUrl + (share?.id || '00000000-0000-0000-0000-000000000001')} title={task.title} overlay={share?.id ? '' : i18n.t('shareQRCode.sample')} text={share ? i18n.t('shareQRCode.used', { num: share.sharedWith.length }) : null} className="my-2" />}
                        <VStack space='lg' className="w-[100%] pt-2 px-3">
                            <FloatingLabelInput label={i18n.t('shareQRCode.location')} value={info} h='h-[100px]' multiline={true} onChangeText={setInfo} isDisabled={!isEdit} />
                            <BasicElement
                                media={share ? share.image?.id : (anonymous ? user.publicImage?.id : user.id) || avatar1}
                                sync={'/contact/media/' + (share ? share.image?.id : (anonymous ? user.publicImage?.id : user.id))}
                                title={i18n.t('shareQRCode.actProfile')}
                                text={share ? share.name : (anonymous ? user.publicName : (user.preferredName || user.mail))}
                            />
                            {!share && <SwitchableElement header={i18n.t('shareQRCode.publish')} mainText={i18n.t('shareQRCode.profile')} isChecked={!anonymous} onToggle={() => setAnonymous(!anonymous)} disabled={!isEdit || share != undefined} />}
                            <SwitchableElement header={i18n.t('shareQRCode.status')} mainText={i18n.t('shareQRCode.active')} isChecked={active} onToggle={() => setActive(!active)} disabled={!isEdit} />
                            {false && !isEdit && <Text className="mx-2 text-xl text-secondary-900">{i18n.t('shareQRCode.text')}</Text>}
                            {isEdit && share && server.online && <>
                                <Text className="text-2xl text-secondary-900">{i18n.t('shareQRCode.delete')}</Text>
                                <PressableElement mainText={i18n.t('shareQRCode.deleteInfo')} color='text-error-600' pressed={() => setShowModal(true)} />
                            </>}
                        </VStack>
                        <ModalConfirm showModal={showModal} closeModal={closeModal} title='shareQRCode.deleteInfo' text='shareQRCode.confirmText' buttonOk='shareQRCode.delete' />
                    </VStack>
                </ScrollView>
                <Footer navigation={navigation} actions={actions} button={!isEdit && server.online ? { action: generatePDF, info: 'shareQRCode.genPDF' } : !share && { action: () => switchScreen(navigation, 'accountSettings', { isEdit: false, isAnonymous: true }), info: 'shareQRCode.publicEdit' }} />
            </View>
        </BackGesture>
    );
}